import React, {useContext} from "react";
import PropTypes from 'prop-types';
import {Card, CardContent} from "@material-ui/core";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useResponsiveStyles} from "../../../../../../../Hooks/useResponsiveStyles";
import {useCurrentResolution} from "../../../../../../../Hooks/useCurrentResolution";


function generateStyles(styles) {
    const {
        boxShadow,
        shadowColor = "#000000",
        border = "",
        borderColor = "#000000",
        flexDirection = "column",
        justifyContent,
        alignItems = 'baseline',
        background,
        padding
    } = styles;

    return {
        wrapperStyle: {
            width: '100%',
            height: '100%',
            boxShadow: `${boxShadow} ${shadowColor}`,
            borderTop: `${border.split(" ")[0] || 0} solid`,
            borderRight: `${border.split(" ")[1] || 0} solid`,
            borderBottom: `${border.split(" ")[2] || 0} solid`,
            borderLeft: `${border.split(" ")[3] || 0} solid`,
            borderColor: borderColor,
        },
        cardStyle: {
            padding,
            background,
            height: '100%',
            overflowY: 'auto'
        },
        contentStyle: {
            flexDirection,
            justifyContent,
            alignItems,
            display: 'flex'
        }
    }
}


const CardComponent = ({component, path, index: parentIndex}) => {
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const {styles: sourceStyles, children = []} = component;
    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(sourceStyles, currentResolution);
    const hasChildren = children && children.length;
    const {wrapperStyle, cardStyle, contentStyle} = generateStyles(styles);

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <div style={wrapperStyle} ref={drop}>
            <Card
                style={cardStyle}
            >
                <CardContent
                    style={{...contentStyle, padding: 0, height: '100%'}}
                >
                    {hasChildren ? (
                        children.map((item, index) => {
                            return (
                                <RenderComponents
                                    key={index}
                                    type={item.type}
                                    item={item}
                                    index={index}
                                    path={`${path}.children.${index}`}
                                    parentPath={path}
                                />
                            )
                        })
                    ) : (
                        isOverCurrent && (
                            <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                            </div>
                        )
                    )}

                </CardContent>
            </Card>
        </div>
    )
};

CardComponent.propTypes = {
    component: PropTypes.object,
    path: PropTypes.string,
    index: PropTypes.number
};

export default CardComponent;